const VAST_TAG_REGEX = /<vast[\s>]/i
const VIDEO_FILE_REGEX = /\.(mp4|webm|m3u8|mov)(\?|#|$)/i
const STARTS_WITH_IMG_TAG_REGEX = /^\s*<img[\s>]/i

/**
 * Some bidders (e.g. tappx) occasionally report mediaType: 'video' with an outstream renderer
 * configured, but the actual vastXml/ad markup is just a tracking pixel + script — no <VAST>
 * document and no direct media file reference. Feeding that into a video player (IMA or the
 * bidder's own renderer) fails outright, losing the placement entirely. This detects that case
 * so the bid can be rendered as a banner instead of dropped.
 *
 * A bid is considered playable video markup if it contains a <VAST> document or a direct video
 * file reference (in case some bidder skips the VAST wrapper and just points at a media file).
 * If it starts with an <img> tag, it's definitely just a tracking pixel, regardless of anything
 * else in the string.
 */
export function hasValidVastMarkup(markup: string | null | undefined): boolean {
    if (!markup || STARTS_WITH_IMG_TAG_REGEX.test(markup)) {
        return false
    }
    return VAST_TAG_REGEX.test(markup) || VIDEO_FILE_REGEX.test(markup)
}
